import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { Box, Heading } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import * as Yup from 'yup';
import { InputCustom, ButtonCustom } from '../UI';
import AuthLinks from '../authBottomLinks';

interface PhoneInputFormProps {
  onNext: (phone: string) => void;
}

const link1 = '/signUp';
const link2 = '/signUp';
const linkName1 = 'Нет аккаунта?';
const linkName2 = 'Зарегистрироваться';

const validationSchema = Yup.object().shape({
  phone: Yup.string().required('Введите номер телефона'),
});

export const PhoneInputForm: React.FC<PhoneInputFormProps> = ({ onNext }) => {
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (isTimerActive) {
      timer = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            setIsTimerActive(false);
            clearInterval(timer!);
            return 60;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [isTimerActive]);

  const handleSubmit = async (values: { phone: string }) => {
    onNext(values.phone);
    setIsTimerActive(true);
  };

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '100%',
          height: '100vh',
          padding: '101px 0 110px',
        }}
      >
        <Formik
          initialValues={{ phone: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, values, handleChange }) => (
            <Form>
              <Heading mb={6}>Восстановление пароля</Heading>
              <InputCustom
                label="Телефон"
                name="phone"
                value={values.phone}
                onChange={handleChange}
                errorMessage={touched.phone && errors.phone}
                placeholder="+7 999 99-99-99"
              />
              <ButtonCustom
                variant="withBackground"
                mt={4}
                w="full"
                type="submit"
                isDisabled={isTimerActive}
              >
                {isTimerActive ? `Отправить через ${formatTime(timeLeft)}` : 'Получить код'}
              </ButtonCustom>
            </Form>
          )}
        </Formik>
        <AuthLinks link1Name={linkName1} link1Url={link1} link2Name={linkName2} link2Url={link2} />
      </Box>
    </motion.div>
  );
};
